import dayjs from '@jobcost-monorepo/dayjs-config';
import {
  ApiResponse,
  IBaseModel,
  IKeyValue,
  IListResponse,
  Paths,
} from '../../common';
import { KeyValue } from '@jobcost-monorepo/utils';

export const getValueByPath = (obj: any, path: string): string => {
  return path.split('.').reduce((acc, key) => acc && acc[key], obj);
};

export const generateDescriptionForKeyValues = <T extends IBaseModel>(
  obj: T,
  paths: Paths<T>[],
): string => {
  return paths
    .map((path) => {
      const value = getValueByPath(obj, path);
      return value !== undefined && value !== null ? value.toString() : '';
    })
    .join(' ');
};

export const generateKeyValue = <T extends IBaseModel>(
  data: IListResponse<T>,
  paths: Paths<T>[],
): KeyValue[] => {
  const values: IKeyValue[] = data?.data?.map((el) => ({
    id: el.id,
    description: generateDescriptionForKeyValues(el, paths ?? []),
  }));
  return (
    values?.map(
      (el) =>
        ({
          id: el.id,
          name: el.description,
        }) as KeyValue,
    ) ?? []
  );
};

export const generateKeyValueFromSingleElement = <T extends IBaseModel>(
  data: ApiResponse<T>,
  paths: Paths<T>[],
): KeyValue | undefined => {
  const el = data.data;
  return el
    ? ({
        id: el.id,
        name: generateDescriptionForKeyValues(el, paths ?? []),
      } as KeyValue)
    : undefined;
};

export const getMonthsKeyValues = () =>
  Array.from({ length: 12 }, (v, i): KeyValue => {
    const monthName = dayjs.utc().locale('it').month(i).format('MMMM');
    const capitalizedMonthName =
      monthName.charAt(0).toUpperCase() + monthName.slice(1);
    return {
      id: i,
      name: capitalizedMonthName,
    };
  });

export const getYearsKeyValues = () => {
  return Array.from(
    { length: 30 },
    (v, i): KeyValue => ({
      id: 2020 + i,
      name: `${2020 + i}`,
    }),
  );
};
